// extracted by mini-css-extract-plugin
module.exports = {"communityPost":"_1A0WbxH4mDIQO23C4XkHlp","mdMessage":"_1vbskwQdy2etRwSFwXKxOa"};